import React, { Component } from 'react'
import { connect } from 'react-redux'; 

import Modal from '../../../../components/Modal'
import LoadMask from '../../../../components/LoadMask'
import LuftUserForm from './LuftUserForm'

import { getUpdateLuftUserUI, getRemoveLuftUserUI } from '../../../../redux/selectors';
import { fetchLuftUsers, fetchUpdateLuftUser, fetchRemoveLuftUser, updateLuftUserClear, removeLuftUserClear } from '../../../../redux/admin-luft-users'

class EditLuftUserModal extends Component {

    componentWillUnmount() {
        const { dispatch } = this.props;
        dispatch(updateLuftUserClear());
        dispatch(removeLuftUserClear());
    }

    _submit = ({id, name, email, subsidiaries, roles}) => {
        const { dispatch, onDismiss } = this.props
        
        dispatch(fetchUpdateLuftUser(id, name, email, subsidiaries, roles)).then(
            () => {
                onDismiss()
                dispatch(fetchLuftUsers())
            },
            // reject
            () => {}
        )
    }

    _removeUser = (userData) => {
        const { dispatch, onDismiss } = this.props

        dispatch(fetchRemoveLuftUser(userData.id)).then(
            () => {
                onDismiss()
                dispatch(fetchLuftUsers())
            }
        )
    }

    render() {
        const { updateUI, removeUI, userData, subsidiaries, onDismiss } = this.props

        return (
            <Modal
                title="Editar usuário"
                size="small"
                onBackdropClick={onDismiss}
            >
                <LuftUserForm
                    errorMessage={updateUI.error || removeUI.error}
                    userData={userData}
                    subsidiaries={subsidiaries}
                    onDismiss={onDismiss}
                    onSubmit={this._submit}
                    onRemove={this._removeUser}
                />
                { 
                    (updateUI.isFetching || removeUI.isFetching) &&
                        <LoadMask text={updateUI.isFetching ? 'Salvando...' : 'Removendo...'} />
                }
            </Modal>            
        )
    }
}

function mapStateToProps(state) {
	return {
        updateUI: getUpdateLuftUserUI(state),
        removeUI: getRemoveLuftUserUI(state)
	};
}

export default connect(mapStateToProps)(EditLuftUserModal)
